import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '@core/config/api-url.token';
import { SUPPRESS_ERROR_TOAST } from '@core/http/http-context-tokens';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { ClinicalReportCapabilities } from '../../../domain/models/clinical-report-capabilities.model';
import {
  ClinicalReportGenerationRequestDto,
  ClinicalReportGenerationResponseDto,
} from '../../dtos/clinical-report-generation.dto';

@Injectable()
export class ClinicalReportsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public getCapabilities(): Observable<ClinicalReportCapabilities> {
    return this.http.get<ClinicalReportCapabilities>(
      `${this.apiUrl}${API_ENDPOINTS.clinicalReports.capabilities}`,
      { context: new HttpContext().set(SUPPRESS_ERROR_TOAST, true) },
    );
  }

  public generate(request: ClinicalReportGenerationRequestDto): Observable<ClinicalReportGenerationResponseDto> {
    return this.http.post<ClinicalReportGenerationResponseDto>(
      `${this.apiUrl}${API_ENDPOINTS.clinicalReports.generate}`,
      request,
      { context: new HttpContext().set(SUPPRESS_ERROR_TOAST, true) },
    );
  }
}
